import { EmptyState } from '@backstage/core-components';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { EntityRefLink, useEntity } from '@backstage/plugin-catalog-react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { hierachyProps } from '../../redux/slices/hierachySlice';
import { fetchData, urls } from '@internal/backstage-plugin-dh-dock-shared-common';
import { Entity } from '@backstage/catalog-model';

type ProductTeams={
  name:string;
  domain:string;
}

const DomainOwnedTeamsEntity: FC<{
  setProductData?: (data: Omit<hierachyProps, 'loading' | 'error'>) => void;
}> = ({ setProductData }) => {
  
  const { entity } = useEntity();
  const data = entity?.spec?.children as string[] | undefined;
  const domain=window.location.pathname.split('/')[4];
  const isVs = domain?.includes('_vs_');
  const loading = useSelector((state: RootState) => state.hierachyList.loading);
  const error = useSelector((state: RootState) => state.hierachyList.error);
  const fullHierarchyList = useSelector(
    (state: RootState) => state.hierachyList.response,
  );
  const [teams,setTeams]=useState<ProductTeams[]>([])

  const filteredHierarchy = useMemo(() => {
    
    if (!entity || !fullHierarchyList?.length) return [];

    const entityName = entity.metadata?.name?.trim();

    return fullHierarchyList
      .filter(
        x => x.parent?.replace('group:default/', '').trim() === entityName,
      )
      .flatMap(item => {
        if (item.team?.includes('dh_art')) {
          return fullHierarchyList.filter(child => child.parent === item.team);
        }
        return [item];
      });
  }, [entity, fullHierarchyList]);
  useEffect(() => {
    setProductData?.({ response: filteredHierarchy });
  }, [filteredHierarchy, entity, setProductData]);


  const handleTeams=async()=>{
    for (const team of data!) {
      const teamEntity = await fetchData(`${urls.getTeamDataByTeamName}${team?.replace('group:default/','')}`) as Entity
      const children = teamEntity?.spec?.children as string[] | undefined;
      if(children && children.length>0) {
        setTeams(prevTeams => [...prevTeams, ...children!.map(child => ({ name: child, domain: isVs ? `group:default/${domain}` : entity?.spec?.parent as string }))]);
      }
      else{
        setTeams(prevTeams => [...prevTeams, { name: team, domain: isVs ? `group:default/${domain}` : entity?.spec?.parent as string }]);
      }
    }
  }


  useEffect(() => {
      if(data?.length!>0 && isVs){
        
        handleTeams()
      }
  }, [data,isVs]);

  return (
    <Card data-testid="entity-group-list">
      <CardHeader title="Product Teams" />
      <br/>
      <Divider/>
      <CardContent>
        {loading ? (
          <LinearProgress />
        ) : (
          <>
            {   
            (filteredHierarchy?.length > 0 && filteredHierarchy?.[0]?.team) && 
            !error ? (
              <Table aria-label="group list" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>NAME</TableCell>
                    <TableCell>DOMAIN</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                   { isVs && teams
                    ?.filter((item, index, self) => {
                      return self.findIndex(i => i.name === item.name) === index;
                    })
                    .filter(
                      item => !item?.name?.toLowerCase().includes('contributors'),
                    )
                    ?.map(item => {

                      return (
                        <TableRow key={item.name}>
                          <TableCell>
                            <b>
                              <EntityRefLink entityRef={item.name} />
                            </b>
                          </TableCell>
                          <TableCell>
                            <b>
                              <EntityRefLink
                                entityRef={item.domain}
                              />
                            </b>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {!isVs && data
                    ?.filter((item, index, self) => {
                      return self.findIndex(i => i === item) === index;
                    })
                    .filter(
                      item => !item?.toLowerCase().includes('contributors'),
                    )
                    ?.map(item => {

                      return (
                        <TableRow key={item}>
                          <TableCell>
                            <b>
                              <EntityRefLink entityRef={item} />
                            </b>
                          </TableCell>
                          <TableCell>
                            <b>
                              <EntityRefLink
                                entityRef={isVs ? `group:default/${domain}` : entity?.spec?.parent as string}
                              />
                            </b>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            ) : (
              <EmptyState missing="data" title="No Teams found" />
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default DomainOwnedTeamsEntity;
